import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
// פונקציית עיצוב למספרים
import { FundAction } from "../../interfaces/DTO/mislaka_xml_models";
import {
  formatActionBalanceActionComponent,
  formatActionTypeCode,
  formatTransferRequestType,
} from "../../utils/enumFormatter";
import { formatCurrency, formatHandlerCode } from "../../utils/namesFormater";

interface FundActionTableProps {
  fund_actions: FundAction[]; // מערך ה-FundAction להצגה
}

const FundActionTable: React.FC<FundActionTableProps> = ({ fund_actions }) => {
  return (
    <Box sx={{ p: 1 }}>
      {fund_actions.length > 0 && (
        <>
          <Typography variant="h5" gutterBottom>
            פרטי משיכות וניודים יוצאים
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>סוג פעולה</TableCell>
                  <TableCell>רכיב נמשך/ניוד</TableCell>
                  <TableCell>סכום משיכה/ניוד</TableCell>
                  <TableCell>תאריך ביצוע</TableCell>
                  <TableCell>תאריך ערך</TableCell>
                  <TableCell>קנס</TableCell>
                  <TableCell>קוד יצרן מקבל</TableCell>
                  <TableCell>קוד קופה מקבלת</TableCell>
                  <TableCell>שם קופה מקבלת</TableCell>
                  <TableCell>עילת העברה</TableCell>
                  <TableCell>מועד קובע</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fund_actions.map((action, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      {formatActionTypeCode(action.action_type_code)}
                    </TableCell>
                    <TableCell>
                      {formatActionBalanceActionComponent(
                        action.balance_component
                      )}
                    </TableCell>
                    <TableCell sx={{ direction: "ltr" }}>
                      {formatCurrency(action.withdrawal_amount)}
                    </TableCell>
                    <TableCell>{action.execution_date}</TableCell>
                    <TableCell>{action.value_date}</TableCell>
                    <TableCell>
                      {action.penalty_amount !== null &&
                      action.penalty_amount > 0
                        ? formatCurrency(action.penalty_amount)
                        : ""}
                    </TableCell>
                    <TableCell>{formatHandlerCode(action.receiving_handler_code) || ""}</TableCell>
                    <TableCell>{action.receiving_fund_code || ""}</TableCell>
                    <TableCell>{action.receiving_fund_name || ""}</TableCell>
                    <TableCell>{formatTransferRequestType(action.transfer_reason) || ""}</TableCell>
                    <TableCell>{action.determining_date || ""}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default FundActionTable;
